export type QuestionnaireAnswerValue = string | string[] | null;

export interface QuestionnaireAnswer {
  value: QuestionnaireAnswerValue;
  text: string | string[] | null;
  otherText?: string | null;
}

export interface QuestionnaireQuestionOption {
  id?: string;
  order: number;
  label: string;
  value: string;
  is_other?: boolean;
}

export const QUESTIONNAIRE_ANSWER_TYPES = [
  "yes_no",
  "single_choice",
  "multiple_choice",
  "free_text",
] as const;

export type QuestionnaireAnswerType = (typeof QUESTIONNAIRE_ANSWER_TYPES)[number];

export const DEFAULT_QUESTIONNAIRE_ANSWER_TYPE: QuestionnaireAnswerType = "single_choice";

export const isQuestionnaireAnswerType = (value: string): value is QuestionnaireAnswerType => {
  return QUESTIONNAIRE_ANSWER_TYPES.includes(value as QuestionnaireAnswerType);
};

export const QUESTIONNAIRE_SINGLE_SELECT_ANSWER_TYPES: ReadonlyArray<QuestionnaireAnswerType> = [
  "yes_no",
  "single_choice",
];

export interface QuestionnaireStepQuestion {
  id: string;
  question_key: string;
  text: string;
  order: number;
  answer_type: QuestionnaireAnswerType;
  mandatory: boolean;
  options: QuestionnaireQuestionOption[];
}

export interface QuestionnaireSubmitForm {
  answer: QuestionnaireAnswer;
}

export interface IQuestionnaireQuestionRaw {
  id: string;
  question_key: string;
  text: string;
  order: number;
  answer_type: string;
  mandatory: boolean;
  options?: Array<{
    id?: string;
    order: number;
    label: string;
    value: string | number;
    is_other?: boolean;
  }>;
}

export type QuestionnaireResultPrimitive = string | number | boolean;
export type QuestionnaireResultValue = QuestionnaireResultPrimitive | QuestionnaireResultPrimitive[] | null;

export interface QuestionnaireResultEntry {
  value?: QuestionnaireResultValue;
  text?: string | string[] | null;
}

export type QuestionnaireResult = Record<string, QuestionnaireResultEntry>;
